import resolvePromise from '../helper/resolved_promise';
import CatalogItemsConstants from '../constants/catalog_items_constants';
import Dispatcher from '../dispatcher';

function setCatalogItemsAction(items) {
    Dispatcher.handleCatalogItemsAction({
        type: CatalogItemsConstants.SET_PRODUCTS_ACTION,
        payload: items
    });

    return resolvePromise();
}

function loadingCatalogItemsAction() {
    Dispatcher.handleCatalogItemsAction({
        type: CatalogItemsConstants.LOAD_CATALOG_ITEMS_ACTION
    });

    return resolvePromise();
}

function setCatalogItemsBuyerAssistUrl(url) {
    Dispatcher.handleCatalogItemsAction({
        type: CatalogItemsConstants.SET_BUYER_ASSIST_URL,
        payload: url
    });

    return resolvePromise();
}

export {
    setCatalogItemsAction,
    loadingCatalogItemsAction,
    setCatalogItemsBuyerAssistUrl,
};